import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createSlots as _createSlots, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "_tc--lighter" }
const _hoisted_2 = { class: "_flex" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_processing_button = _resolveComponent("processing-button")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_base_summary_list = _resolveComponent("base-summary-list")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["gfu-collapsible gfu-installments-plan", {'gfu-collapsible--expanded': $data.isOpen }])
  }, [
    _createElementVNode("div", {
      class: "gfu-installments-plan__header",
      onClick: _cache[0] || (_cache[0] = (...args) => ($options.onCollapse && $options.onCollapse(...args))),
      "data-qa": "StretchPay:dropdown"
    }, [
      _createTextVNode(_toDisplayString($options.effectiveHeader) + " ", 1 /* TEXT */),
      _createVNode(_component_base_icon, { name: $options.chevronIcon }, null, 8 /* PROPS */, ["name"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(['gfu-installments-plan__information', {'is-open': $data.isOpen }])
    }, [
      _renderSlot(_ctx.$slots, "default"),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.installmentsDetailsModel, (installmentDetails) => {
        return (_openBlock(), _createElementBlock("div", {
          key: installmentDetails.title
        }, [
          _createVNode(_component_base_summary_list, {
            class: "_mt-2 _tc--base",
            size: "small",
            "summary-list-data": installmentDetails.listItems,
            "data-qa": installmentDetails.dataQaForInstallment
          }, _createSlots({
            description: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, _toDisplayString(installmentDetails.listTitle), 1 /* TEXT */)
            ]),
            _: 2 /* DYNAMIC */
          }, [
            (installmentDetails.isRetryPaymentButtonVisible)
              ? {
                  name: "actions",
                  fn: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_tooltip, {
                        text: installmentDetails.buttonTooltipText,
                        enabled: !!installmentDetails.buttonTooltipText
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_processing_button, {
                            width: "wide",
                            theme: "accent",
                            display: "block",
                            enabled: !installmentDetails.buttonTooltipText,
                            "is-action-in-progress": _ctx.isChargingInstallments,
                            "is-processing": installmentDetails.paymentInProgress,
                            status: installmentDetails.actionStatus,
                            onClick: $event => ($options.onRetryInstallmentPayment(installmentDetails.paymentID)),
                            "data-qa": installmentDetails.dataQaForButton
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.Resources.YourPledge.RetryInstallmentButton), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["enabled", "is-action-in-progress", "is-processing", "status", "onClick", "data-qa"])
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["text", "enabled"])
                    ])
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["summary-list-data", "data-qa"])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}